import { TemplateElement, html, defineElement, unsafeHTML, when } from '@webtides/element-js';
import style from './rich-text.css';

/**
 * @property {string} headline
 * @property {string} text
 * @property {number} columns
 */
export default class RichText extends TemplateElement {
    constructor() {
        super({ styles: [style], propertyOptions: { columns: { reflect: true } } });
    }

    properties() {
        return {
            headline: '',
            text: '',
            columns: 1, // 1 || 2
        };
    }

    template() {
        return html`
            <div class="richtext">
                ${when(this.headline, html` <h2>${this.headline}</h2> `)} ${unsafeHTML(this.text)}
            </div>
        `;
    }
}

defineElement('mb-rich-text', RichText);
